export default __webpack_public_path__ + "static/media/tajima.55b55b49.png";